import React, { useEffect, useState } from 'react';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import { detectLanguage, getMessages, defaultLanguage } from './i18n';
import products from './Components/Projects/ProjectSimulateJson';
import members from './Components/Team/CardSimulateJson';
import services from './Components/Services/ServiceSimulateJson';

import './App.css';

function App() {
  const [language, setLanguage] = useState(defaultLanguage);

  useEffect(() => {
    const storedLanguage = localStorage.getItem('nulamar-language');
    const detected = storedLanguage || detectLanguage();
    setLanguage(detected);
  }, []);

  useEffect(() => {
    localStorage.setItem('nulamar-language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = getMessages(language);
  const featuredProject = products[0];
  const teamLead = members[0];
  const primaryService = services[0];

  return (
    <div className="App landing-shell">
      <Navbar language={language} setLanguage={setLanguage} t={t} />
      <main className="landing-page">
        <section id="home" className="landing-section hero-section">
          <div className="section-inner hero-layout">
            <div className="hero-copy-block">
              <p className="eyebrow">{t.home.eyebrow}</p>
              <h1 className="hero-title text-focus-in">
                {t.home.titleBefore}
                <span className="highlight">{t.home.titleHighlight}</span>
                {t.home.titleAfter}
              </h1>
              <p className="hero-copy">{t.home.copy}</p>
              <div className="hero-actions">
                <a href="#projects" className="hero-button primary">{t.home.primaryCta}</a>
                <a href="#contact" className="hero-button secondary">{t.home.secondaryCta}</a>
              </div>
            </div>
            <div className="hero-highlights" aria-label="Key highlights">
              <div className="hero-highlight">
                <span className="hero-highlight-label">Focus</span>
                <strong>Web products</strong>
              </div>
              <div className="hero-highlight">
                <span className="hero-highlight-label">Stack</span>
                <strong>Design + React</strong>
              </div>
              <div className="hero-highlight">
                <span className="hero-highlight-label">Delivery</span>
                <strong>Portfolio-ready</strong>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="landing-section">
          <div className="section-inner split-layout">
            <div>
              <h2 className="main_title">{t.about.title}</h2>
              <p className="section-copy">{t.about.body}</p>
            </div>
            <div className="profile-card">
              <p className="profile-label">Team lead</p>
              <h3>{teamLead.nome}</h3>
              <p>{teamLead.funcao}</p>
              <p>{teamLead.habilidades_tecnicas}</p>
            </div>
          </div>
        </section>

        <section id="projects" className="landing-section">
          <div className="section-inner split-layout">
            <div>
              <h2 className="main_title">{t.projects.title}</h2>
              <p className="section-copy">{t.projects.intro}</p>
              <div className="project-feature">
                <span className="project-feature-label">Featured</span>
                <h3>{featuredProject.titulo}</h3>
                <p>{featuredProject.descricao}</p>
                <p className="project-meta">{featuredProject.responsaveis_tecnicos}</p>
                <a href={featuredProject.link_acesso} target="_blank" rel="noopener noreferrer" className="hero-button secondary project-link">
                  Open project
                </a>
              </div>
            </div>
            <div className="stack-list">
              {products.slice(0, 3).map((product) => (
                <article className="stack-card" key={product.id}>
                  <h3>{product.titulo}</h3>
                  <p>{product.descricao}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="services" className="landing-section">
          <div className="section-inner split-layout">
            <div>
              <h2 className="main_title">{t.services.title}</h2>
              <p className="section-copy">A focused set of services designed to move from idea to launch with less friction.</p>
            </div>
            <div className="stack-list">
              {services.slice(0, 3).map((service) => (
                <article className="stack-card" key={service.id}>
                  <h3>{service.name}</h3>
                  <p>{service.description}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="landing-section">
          <div className="section-inner split-layout">
            <div>
              <h2 className="main_title">{t.contact.title}</h2>
              <p className="section-copy">{t.contact.body}</p>
              <p className="contact-line">
                {t.contact.emailLabel}{' '}
                <a href="mailto:nulamar.supp@gmail.com" className="nav-link">nulamar.supp@gmail.com</a>
              </p>
            </div>
            <div className="stack-list">
              <article className="stack-card">
                <h3>{teamLead.nome}</h3>
                <p>{teamLead.redes_sociais.map((rede) => rede.url).join(' | ')}</p>
              </article>
              <article className="stack-card">
                <h3>Availability</h3>
                <p>Open for freelance and collaborative projects.</p>
              </article>
              <article className="stack-card">
                <h3>{primaryService.name}</h3>
                <p>{primaryService.description}</p>
              </article>
            </div>
          </div>
        </section>
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
